/* eslint-disable import/no-unresolved */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ItemType } from '@/types/utils';

interface CartState {
  items: ItemType[];
  subtotal: number;
}

const initialState: CartState = {
  items: [],
  subtotal: 0,
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state: CartState, { payload }: PayloadAction<ItemType>) => {
      const cartItem = payload;

      const existingItem = state.items.find(
        (item) => item.item_code === payload.item_code,
      );

      if (existingItem) {
        existingItem.qty += 1;
        state.subtotal += existingItem.price_list_rate;
      } else {
        state.items.push(cartItem);
        state.subtotal += cartItem.price_list_rate;
      }
    },
    updateItemQuantity: (
      state: CartState,
      { payload }: PayloadAction<{ item_code: string; qty: number }>,
    ) => {
      const existingItem = state.items.find(
        (item) => item.item_code === payload.item_code,
      );
      if (existingItem) {
        const quantityDifference = payload.qty - existingItem.qty;
        state.subtotal += quantityDifference * existingItem.price_list_rate;
        existingItem.qty = payload.qty;
      }
    },

    addBulkItemsToCart: (
      state: CartState,
      { payload }: PayloadAction<ItemType[]>,
    ) => {
      state.items = payload;
      state.subtotal = payload.reduce(
        (
          total: number,
          current: { price_list_rate: number; qty: number },
        ): number => current.price_list_rate * current.qty + total,
        0,
      );
    },
    reduceFromCart: (
      state: CartState,
      { payload }: PayloadAction<ItemType>,
    ) => {
      const cartItem = payload;

      const existingItem = state.items.find(
        (item) => item.item_code === payload.item_code,
      );

      if (existingItem?.qty === 1) {
        state.items = state.items.filter(
          (item) => item.item_code !== cartItem.item_code,
        );
        state.subtotal -= existingItem!.price_list_rate;
      } else {
        existingItem!.qty -= 1;
        state.subtotal -= cartItem.price_list_rate;
      }
    },
  },
});

export const {
  addToCart,
  reduceFromCart,
  addBulkItemsToCart,
  updateItemQuantity,
} = cartSlice.actions;

export default cartSlice.reducer;
